// extracted by mini-css-extract-plugin
export default {"MainButtonContainer":"HeaderButtonContainer_MainButtonContainer__q2+p+","MainButton":"HeaderButtonContainer_MainButton__f8dXU","Purple":"HeaderButtonContainer_Purple__RAMFJ"};